module.exports = __webpack_public_path__ + "img/settings.7a96b649.svg";